import { render, staticRenderFns } from "./producerAnalysis.vue?vue&type=template&id=a31a3004&scoped=true&"
import script from "./producerAnalysis.vue?vue&type=script&lang=js&"
export * from "./producerAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./producerAnalysis.vue?vue&type=style&index=0&id=a31a3004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31a3004",
  null
  
)

export default component.exports